const topics = [
  { name: '最新上映', heat: '9.8万', icon: 'ri-movie-line', color: 'primary' as const },
  { name: '热门推荐', heat: '8.5万', icon: 'ri-fire-line', color: 'primary' as const },
  { name: '动作大片', heat: '7.2万', icon: 'ri-shield-flash-line', color: 'accent' as const },
  { name: '喜剧搞笑', heat: '6.9万', icon: 'ri-emotion-laugh-line', color: 'accent' as const },
  { name: '悬疑推理', heat: '5.8万', icon: 'ri-search-eye-line', color: 'primary' as const },
  { name: '爱情文艺', heat: '5.3万', icon: 'ri-heart-line', color: 'accent' as const },
  { name: '科幻奇幻', heat: '4.9万', icon: 'ri-rocket-line', color: 'primary' as const },
  { name: '动画动漫', heat: '4.6万', icon: 'ri-ghost-line', color: 'accent' as const },
  { name: '纪录纪实', heat: '3.8万', icon: 'ri-camera-line', color: 'primary' as const },
  { name: '综艺娱乐', heat: '3.2万', icon: 'ri-tv-line', color: 'accent' as const },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            发现当下最受关注的热门视频分类与话题标签
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            {topics.map((topic, i) => (
              <span
                key={i}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  topic.color === 'primary'
                    ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                    : 'bg-accent-50 border-accent-200 text-accent-700 hover:bg-accent-100'
                }`}
              >
                <span
                  className={`w-6 h-6 flex items-center justify-center rounded-full ${
                    topic.color === 'primary' ? 'bg-primary-500 text-white' : 'bg-accent-500 text-white'
                  }`}
                >
                  <i className={`${topic.icon} text-xs`}></i>
                </span>
                {topic.name}
                <span className="text-xs opacity-60 ml-1">{topic.heat}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}